import {GetterTree} from 'vuex'
import {StatisticState} from './types';
import {RootState} from '@/store/types';

export const getters: GetterTree<StatisticState, RootState> = {
    smsStaticDetail: state => state.smsStaticDetail,
    smsStaticDetailFlag: state => state.smsStaticDetailFlag,
    smsStatisticGroup: state => state.smsStatisticGroup,
    groupBy: state => state.groupBy,
    groupByOptionally: state => state.groupByOptionally,
};
